import { isDisabled } from 'app/infrastructure/data/date';
import { ValidationLevel, ValidationProps } from 'ui';

export const getDisabledValidation = (value: Date, message: string): ValidationProps =>
  isDisabled(value) ?
    {
      level: ValidationLevel.warning, messages: [{
        level: ValidationLevel.warning,
        message
      }]
    } : undefined;
